export default __webpack_public_path__ + "static/media/clear.aa2ac6da.svg";